<onyx-modal
  variant="center"
  [heading]="`${I18N}.heading` | translate: { identifier: data.identifier }"
  [close$]="close$"
  (closeModal)="dialogRef.close()"
>
  @let controls = form.controls;
  <form [formGroup]="form" [onyxAutoFocus]="true">
    <onyx-form-group [controls]="controls.reason" label="labels.reason">
      <div class="group">
        @for (reason of orderCancellationReasons$ | async; track reason) {
          <onyx-radio-button
            [formControl]="controls.reason"
            [option]="reason.value"
            [label]="reason.name"
          ></onyx-radio-button>
        }
      </div>
    </onyx-form-group>

    <onyx-textarea
      [formControl]="controls.note"
      [placeholder]="`${I18N}.${controls.reason.value === OrderCancellationReason.OTHER ? 'requiredComment' : 'optionalComment'}`"
    ></onyx-textarea>

    <onyx-tabs
      [formControl]="controls.chargeParty"
      [tabs]="orderCancellationChargeParty$ | async"
      [label]="`${I18N}.chargeForAppeal`"
      [size]="40"
    ></onyx-tabs>

    @let chargeAmountGroup = controls.chargeAmount;
    @if (chargeAmountGroup.enabled) {
      @let chargeAmountControls = chargeAmountGroup.controls;
      <onyx-form-group
        [formGroup]="chargeAmountGroup"
        [controls]="[chargeAmountControls.value, chargeAmountControls.currency]"
        label="labels.penalty"
        [gap]="8"
      >
        <onyx-text-field
          [formControl]="chargeAmountControls.value"
          placeholder="labels.limit"
          [decimalPlaces]="0"
          width="125px"
          [showErrors]="false"
        ></onyx-text-field>

        <onyx-dropdown
          [formControl]="chargeAmountControls.currency"
          [options]="currencies$ | async"
          width="80px"
          [showErrors]="false"
        ></onyx-dropdown>
      </onyx-form-group>
    }
  </form>

  <ng-container bottomRightOptions>
    <onyx-button variant="outlined" (click)="close$.next()">
      {{ 'labels.cancel' | translate }}
    </onyx-button>

    <onyx-button
      color="red"
      [disabled]="form.invalid"
      [spinner]="loading()"
      (click)="!loading() && form.valid ? submit() : null"
    >
      {{ 'labels.cancelOrder' | translate }}
    </onyx-button>
  </ng-container>
</onyx-modal>
